import { render, staticRenderFns } from "./cardPartograma.vue?vue&type=template&id=459f066e&"
import script from "./cardPartograma.vue?vue&type=script&lang=js&"
export * from "./cardPartograma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports